import { render, staticRenderFns } from "./SelectPuntoVenta.vue?vue&type=template&id=1cd3c4d6&"
import script from "./SelectPuntoVenta.vue?vue&type=script&lang=js&"
export * from "./SelectPuntoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VProgressCircular,VSelect})
